var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionWaitSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-445.000000, -1113.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Wait/Small",
    transform: "translate(445.000000, 1113.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7458072,9.456 L16.5005104,12.297 L13.2541928,9.456 C12.76112,9.024 12.2231296,8.505 12.431384,7.854 C12.9071022,6.371 14.5833455,6.476 16.5005104,6.476 C18.4166545,6.476 20.0949395,6.372 20.5716786,7.853 C20.7829955,8.507 20.2378591,9.026 19.7458072,9.456 M21.3873414,25.264 C22.2438384,26.171 22.3326528,27.429 22.3326528,27.429 L10.6663264,27.429 C10.6663264,27.429 10.7551407,26.171 11.6116377,25.264 C12.4140295,24.414 13.070439,24.239 14.7119732,22.887 C15.8583929,21.942 16.4994896,20.571 16.4994896,20.571 C16.4994896,20.571 17.1405863,21.942 18.287006,22.887 C19.9285402,24.239 20.5849497,24.414 21.3873414,25.264 M23.1820038,0 L6,0 L6,4.109 C6,7.195 7.35977833,10.108 9.68528511,12.002 L14.5904915,16 L9.68528511,19.997 C7.35977833,21.892 6,24.805 6,27.891 L6,28 C6,30.209 7.7089106,32 9.81799621,32 L27,32 L27,27.891 C27,24.805 25.6392008,21.892 23.3147149,19.997 L18.4084877,16 L23.3147149,12.002 C25.6392008,10.108 27,7.195 27,4.109 L27,4 C27,1.79 25.2910894,0 23.1820038,0",
    id: 230
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionWaitSmall);
export default __webpack_public_path__ + "static/media/navigation-and-action-wait-small.d9159a24.svg";
export { ForwardRef as ReactComponent };